export const buildWaitlistFilters = (filters) => {
  const params = {};
  const query = String(filters?.query || "").trim();
  const paid = String(filters?.paid || "").trim();
  const paymentStatus = String(filters?.paymentStatus || "").trim();
  const messageTemplate = String(filters?.messageTemplate || "").trim();

  if (query) {
    params.q = query;
    params.search = query;
  }

  if (paid) {
    params.paid = paid;
  }

  if (paymentStatus) {
    params.payment_status = paymentStatus;
  }

  if (messageTemplate) {
    params.message_template = messageTemplate;
  }

  return params;
};

export const toQueryString = (params) => {
  const searchParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    const normalized = String(value).trim();
    if (!normalized) return;
    searchParams.set(key, normalized);
  });

  return searchParams.toString();
};

export const triggerBlobDownload = (blob, filename) => {
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
};
